<!-- <section class="page-title page-title-layout3 text-center bg-overlay bg-parallax " style="
    background-size: cover; background-position: center center;">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <h1 class="pagetitle__heading mb-10">Research-Team</h1>
                <nav>
                    <ol class="breadcrumb justify-content-center mb-0">
                        <li class="breadcrumb-item"><a routerLink="../../home">home</a></li>
                        <li class="breadcrumb-item"><a routerLink="../../our-team">Research-Team</a></li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</section> -->

<!-- <div class="preloader" [hidden]="load">
    <div class="loading">
        <img src="assets/images/loader/loader.svg">
    </div>
</div> -->

<app-loading [hidden]="load"></app-loading>


<section class="text-content pt-80 pb-80">
    <div class="container">

        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-4 offset-lg-1">
                <p style="text-align: center;">
                    <img style="height: 250px;    border: 15px solid #019cce;
                border-radius: 50px 0px 50px 50px;box-shadow: 17px 25px 27px 14px #ccc;" src="https://api2.wcrg.org:444/images/post/{{TeamImage}}">
                </p>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-7" style="padding: 52px;">
                <h5 class="text__block-title mb-20">{{TeamName}}</h5>
                <h5 class="text__block-title mb-20"> {{TeamDsc}}</h5>
                <p *ngIf="email" class="member__desc">Email: {{email}}</p>
                <p *ngIf="email2" class="member__desc">Email: {{email2}}</p>
                <!-- <ul style="border-left: 0;flex-direction: row-reverse;position: absolute;" class="portfolio-sharing list-unstyled d-flex flex-wrap mb-0 mt-5">
                  <li>
                    <a target="_blank" >
                        <i class="fa fa-linkedin"></i>
                    </a>
                </li>
                <li>
                  <a target="_blank" >
                      <i class="ai ai-google-scholar"></i>
                  </a>
              </li>
              <li>
                <a target="_blank" >
                    <i class="fa fa-pinterest"></i>
                </a>
            </li>
                </ul> -->
                <ul class="portfolio-sharing list-unstyled d-flex flex-wrap mb-0 mt-5" style="border-left: 0;flex-direction: row-reverse;    position: absolute;">
                    <li>
                        <a class="btn btn__secondary btn__social" target="_blank" href="{{linkedin}}">
                            <i class="fa fa-linkedin">

                      </i>
                        </a>
                    </li>
                    <li>
                        <a class="btn btn__secondary btn__social" target="_blank" href="{{googlescholer}}">
                            <i class="ai ai-google-scholar ">

                    </i>
                        </a>
                    </li>
                    <li>
                        <a class="btn btn__secondary btn__social" target="_blank" href="{{publons}}">
                            <i class="ai ai-publons">

                      </i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row pt-100 pb-60 ">
            <div class="offset-lg-2 col-sm-10 col-md-10 col-lg-10">
                <p class="pDetails" [innerHtml]="TeamDetails"></p>
            </div>
        </div>
    </div>
</section>

<!-- <section class="pt-0 pb-50">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="shadow p-0 rounded-lg">
                    <div class="row row-no-gutter">

                        <div class="col-sm-12 col-md-12 col-lg-12">

                            <ul class="portfolio-sharing list-unstyled d-flex flex-wrap justify-content-end mb-0 mt-5">

                                <li *ngFor="let item of getSectionOurTeamDetails">
                                    <a target="_blank" href="{{item.social_link}}"
                                        class="btn btn__secondary btn__social">
                                        <i class="{{item.social_icon}}"></i>
                                    </a>
                                </li>

                            </ul>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->
